import {
  show,
  hideAll,
} from 'Components/domHelpers';

import HashController from './HashController';
import navbar from './navbar';
import Location from 'Browser/Location';

export default class PageController {
  constructor() {
    this.root = (
      <div class="app-container">
        <nav class="navbar navbar-inverse navbar-embossed navbar-fixed-top">
          <div class="container-fluid">
            <div class="navbar-header">
              <button type="button" class="navbar-toggle collapsed" aria-expanded="false">
                <span class="navbar-toggle-icon tbicon-menu"></span>
                <span class="sr-only">Toggle navigation</span>
              </button>

              <div class="navbar-brand">
                <img alt="Logo" src="img/logo-flat-200-29.png" />
              </div>
            </div>
          </div>
        </nav>

        <nav class="side-menu">
          <div class="side-menu-brand">
            <img alt="Logo" src="img/logo-flat-200-29.png" />
          </div>

          <ul class="list-unstyled" ref={this._menu} />

          <div class="side-menu-toggle" onclick={() => document.body.classList.toggle('menu-closed')}>
            <div />
          </div>
        </nav>

        <div class="content-wrapper" ref={this._pageContainer}>
          <footer>
            &copy;2009-2026 TurboBridge. All Rights Reserved.
          </footer>
        </div>
      </div>
    );

    document.body.append(this.root);

    navbar.init();

    this._curParentPage = null;
    this._scrollSelectors = {};

    this.hashController = new HashController();
    this.pages   = [];

    this.hashController.on('change', () => {
      this.show();
    });

    document.addEventListener('scroll', () => this._onscroll());

    if (Location.query && Location.query.collapse) {
      document.body.classList.add('menu-closed');
    }
  }

  _addMenuItem(item, href, parent) {
    item.li = (
      <li>
        <a href={href} ref={item.a}>{item.title}</a>
      </li>
    );

    parent.appendChild(item.li);
  }

  getPage(hash) {
    var m = hash.match(/^#\/(\w+)(\/(\w+))?$/),
        retPage = false,
        parentPath,
        childPath;

    if (!m) {
      return false;
    }

    parentPath = m[1];
    childPath = m[3];

    this.pages.forEach(function(page) {
      if (parentPath === page.path) {
        retPage = page;

        if (childPath && page.subsections) {
          page.subsections.forEach(function(subpage) {
            if (childPath === subpage.path) {
              retPage = subpage;
              return;
            }
          });
        }
        return;
      }
    });

    return retPage;
  }

  addPage(page) {
    this._addMenuItem(page, '#/' + page.path, this._menu);

    if (page.scrollSelector) {
      this._scrollSelectors[page.scrollSelector] = page;
    }

    if (page.subsections && page.subsections.length) {
      const ul = (
        <ul class="list-unstyled">
        </ul>
      );

      page.a.after(ul);

      page.subsections.forEach(sec => {
        sec.parent = page;

        this._addMenuItem(sec, '#/' + page.path + '/' + sec.path, ul);

        if (sec.scrollSelector) {
          this._scrollSelectors[sec.scrollSelector] = sec;
        }
      });
    }

    this.pages.push(page);
  }

  show() {
    var hash = window.location.hash,
        page,
        scrolled = false;

    if (hash) {
      page = this.getPage(hash);
    }

    // no page specified or matched, revert to default
    if (!page) {
      page = this.pages[0];
    }

    this._curParentPage = page.parent || page;

    if (!this._curParentPage.container) {
      this._curParentPage.container = this._curParentPage.init(this._curParentPage);
      this.addPageContainerToDom(this._curParentPage.container);
    }
    const { container } = this._curParentPage;

    hideAll('.page-container');
    show(container);

    this._updateDisplay(page);

    if (this._curParentPage.handler) {
      this._curParentPage.handler(page, container);
    }

    if (page.scrollSelector) {
      const el = document.querySelector(page.scrollSelector);
      if (el) {
        el.scrollIntoView();
        scrolled = true;
      }
    }

    if (!scrolled) {
      window.scrollTo(0, 0);
    }
  }

  addPageContainerToDom(container) {
    this._pageContainer.prepend(container);
  }

  _updateDisplay(page) {
    let newHash = page.path;
    if (page.parent) {
      newHash = page.parent.path + '/' + newHash;
    }

    newHash = '#/' + newHash;

    this._menu.querySelectorAll('.selected').forEach(el => el.classList.remove('selected'));
    this._curParentPage.li.classList.add('selected');

    // TODO not sure what the point of this is. potentially remove.
    const focusedA = this._menu.querySelector('a:focus');
    if (focusedA && focusedA.blur) {
      focusedA.blur();
    }

    if (page.parent) {
      page.a.classList.add('selected');
    }

    // TODO - is this the right place?
    navbar.closeMenu();

    this.hashController.set(newHash);
  }

  // TODO improve this, it doesn't work great
  // - scrolling up sometimes fails to update the highlighted link
  // - the highlighted link seems a little jumpy
  // - doing lots of getBoundingClientRect() and getComputedStyle() is inefficient, especially in a scroll handler.
  _onscroll() {
    const scrollPos = window.scrollY;

    for (const [ selector, page ] of Object.entries(this._scrollSelectors)) {
      // if current selector is associated with the current parent page...
      if (page === this._curParentPage || (page.parent && page.parent === this._curParentPage)) {
        const el = document.querySelector(selector);
        if (el) {
          const rect = el.getBoundingClientRect();
          const cs = window.getComputedStyle(el);
          const pos = rect.top + window.scrollY - parseInt(cs.marginTop);

          if (pos <= scrollPos && pos + rect.height > scrollPos) {
            this._updateDisplay(page);
            return;
          }
        }
      }
    }
  }
}
